import { isPoseMeshSelectionPointerEvent } from '../bonePicking/meshSelectionPointerEvents';

interface ShouldSuppressKeyPoseCanvasDeselectInput {
  dragging: boolean;
  event: Event;
  pointerMoved: boolean;
  suppressDeselect: boolean;
}

export function shouldSuppressKeyPoseCanvasDeselect({
  dragging,
  event,
  pointerMoved,
  suppressDeselect,
}: ShouldSuppressKeyPoseCanvasDeselectInput) {
  return (
    isPoseMeshSelectionPointerEvent(event) ||
    suppressDeselect ||
    pointerMoved ||
    dragging
  );
}
